import React from "react"
import { graphql } from "gatsby"
import { Cta } from "../libs/helpers"

import * as styles from "./wayfinding.module.scss"

const Wayfinding = ({ topic, explore }) => {
  return (
    <section className={styles['wrap']}>
      <div className={styles['inner']}>
        <div className="next-steps-left">
          <h3>Topics of Interest:</h3>
          { topic &&
          <div className={styles['ctas']}>
            {topic.map((cta, i) => <Cta key={i} cta={{page: cta}}/> )}
          </div>
          }
        </div>
        <div className="next-steps-right">
          <h3>Explore Further:</h3>
          { explore &&
          <div className={styles['ctas']}>
            {explore.map((cta, i) => <Cta key={i} cta={{page: cta}}/> )}
          </div>
          }
        </div>
      </div>
    </section>
  )
}

export default Wayfinding

export const query = graphql`
  fragment WayfindingData on STRAPI__COMPONENT_COMPONENT_WAYFINDING {
    topic {
      path
      title
    }
    explore {
      path
      title
    }
  }
`
